<template>
  <layout-navigation>
    <scrollable-container :class="$style.mainContainer">
      <section :class="$style.page">
        <header :class="$style.header">
          <div class="computersTree">
            <treeselect
              v-model="selectedComputer"
              :multiple="false"
              :options="computersTree"
              :clearable="true"
              :open-on-click="true"
              :placeholder="$t('computers.userSelection')"
              value-format="object"
              :default-expand-level="1"
              :normalizer="normalizer"
              :disable-branch-nodes="false"
            />
          </div>

          <store-based-date-time-picker
            :clearable="false"
            @update="updateData"
          />
          <collapse>
            <div :class="$style.collapseContainer">
              <div :class="$style.headerText">
                Каналы связей
              </div>
              <div :class="$style.checkBoxContainer">
                <div
                  :class="$style.customCheckBoxContainer"
                  @click="toggleSkype"
                >
                  <input
                    v-model="skype"
                    type="checkbox"
                    :class="$style.customCheckbox"
                  >
                  <label>
                    <check-mark v-if="skype" />
                    <div :class="[$style.textContainer]">Msgs</div>
                  </label>
                </div>
                <div
                  :class="$style.customCheckBoxContainer"
                  @click="toggleEmail"
                >
                  <input
                    v-model="email"
                    type="checkbox"
                    :class="$style.customCheckbox"
                  >
                  <label>
                    <check-mark v-if="email" />
                    <div :class="[$style.textContainer]">Email</div>
                  </label>
                </div>
                <div
                  :class="$style.customCheckBoxContainer"
                  @click="toggleSocNet"
                >
                  <input
                    v-model="socNet"
                    type="checkbox"
                    :class="$style.customCheckbox"
                  >
                  <label>
                    <check-mark v-if="socNet" />
                    <div :class="[$style.textContainer]">{{ $t('relations.external') }}</div>
                  </label>
                </div>
              </div>
              <div :class="$style.headerText">
                {{ $t('relations.pinnedHeader') }}
              </div>
              <div :class="$style.checkBoxContainer">
                <div
                  :class="$style.customCheckBoxContainer"
                  @click="toggleIncomin"
                >
                  <input
                    v-model="internalContacts"
                    type="checkbox"
                    :class="$style.customCheckbox"
                  >
                  <label>
                    <check-mark v-if="internalContacts" />
                    <div :class="[$style.textContainer]">{{ $t('relations.internal') }}</div>
                  </label>
                </div>
                <div
                  :class="$style.customCheckBoxContainer"
                  @click="toggleOutcomin"
                >
                  <input
                    v-model="externalContacts"
                    type="checkbox"
                    :class="$style.customCheckbox"
                  >
                  <label>
                    <check-mark v-if="externalContacts" />
                    <div :class="[$style.textContainer]">{{ $t('relations.external') }}</div>
                  </label>
                </div>
              </div>
              <div :class="$style.headerText">
                Сообщений
              </div>
              <div :class="$style.inputContainer">
                <div :class="$style.countContainer">
                  <div :class="$style.countText">
                    Входящих от
                  </div>
                  <div :class="$style.countWrapper">
                    <button
                      :class="$style.defaultButton"
                      @click="updateIncoming(false)"
                    >
                      <minus />
                    </button>
                    <input
                      v-model="incomingCount"
                      type="number"
                      min="0"
                      step="1"
                      :class="$style.numberInput"
                    >
                    <button
                      :class="$style.defaultButton"
                      @click="updateIncoming(true)"
                    >
                      <plus />
                    </button>
                  </div>
                </div>

                <div :class="$style.countContainer">
                  <div :class="$style.countText">
                    {{ $t('relations.outgoingFrom') }}
                    <div :class="$style.countWrapper">
                      <button
                        :class="$style.defaultButton"
                        @click="updateOutgoing(false)"
                      >
                        <minus />
                      </button>
                      <input
                        v-model="outgoingCount"
                        type="number"
                        min="0"
                        step="1"
                        :class="$style.numberInput"
                      >
                      <button
                        :class="$style.defaultButton"
                        @click="updateOutgoing(true)"
                      >
                        <plus @click="updateOutgoing(true)" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div :class="$style.btnFilters">
                <button
                  :class="$style.clearFilters"
                  @click="clearFilters"
                >
                  Очистить
                </button>
                <button
                  :class="$style.applyFilters"
                  @click="applyFilters"
                >
                  Применить
                </button>
              </div>
            </div>
          </collapse>
          <div
            v-if="isMapView"
            :class="$style.control"
          >
            <div
              :class="$style.box"
              @click="changeMode(false)"
            >
              <img
                src="@/assets/images/icons/navigation/menu.svg"
                :title="$t('relations.relationships')"
              >
            </div>
            <div :class="[$style.box, $style.activeBox]">
              <img
                src="@/assets/images/icons/navigation/menu-rotated-selected.svg"
                :title="$t('relations.contactCorrespondence')"
              >
            </div>
          </div>
          <div
            v-else
            :class="$style.control"
          >
            <div :class="[$style.box, $style.activeBox]">
              <img
                src="@/assets/images/icons/navigation/menu-selected.svg"
                :title="$t('relations.relationships')"
              >
            </div>
            <div
              :class="$style.box"
              @click="changeMode(true)"
            >
              <img
                src="@/assets/images/icons/navigation/menu-rotated.svg"
                :title="$t('relations.contactCorrespondence')"
              >
            </div>
          </div>
        </header>
      </section>
      <scrollable-container>
        <loader v-if="isPending" />
        <div
          v-else-if="(currentEmailInQuery || isComputer) && isEmptyData && !isMapView"
          :class="$style.container"
        >
          <table
            id="tableRelations"
            :class="$style.table"
          >
            <thead>
              <tr>
                <th
                  :class="[$style.boderNone, $style.psl0]"
                  style="border-top: 1px solid #e3e3e3; border-left: 1px solid #e3e3e3"
                />
                <th
                  :class="[$style.boderNone, $style.psl100]"
                  style="border-top: 1px solid #e3e3e3"
                />
                <th
                  :class="$style.boderNone"
                  style="border-top: 1px solid #e3e3e3"
                />
                <th
                  v-for="[group, computersInGroup] in groupNameMap"
                  :key="group"
                  :class="$style.tdHeadGroup"
                  :colspan="computersInGroup"
                >
                  {{ getGroupName(group) }}
                </th>
              </tr>
              <tr>
                <th
                  :class="[$style.boderNone, $style.psl0]"
                  style="border-top: 1px solid #e3e3e3; border-left: 1px solid #e3e3e3"
                />
                <th
                  :class="[$style.boderNone, $style.psl100]"
                  style="border-top: 1px solid #e3e3e3; border-left: 1px solid #e3e3e3"
                />
                <th :class="$style.tdHead">
                  <p
                    :class="$style.content"
                    :title="currentEmailInQuery || selectedComputer.name"
                  >
                    {{ currentEmailInQuery || selectedComputer.name }}
                  </p>
                </th>
                <th
                  v-for="([msgLogin, _values], colIndex) in filteredCompInGroups"
                  :key="msgLogin"
                  :class="[
                    $style.tdHead,
                    {
                      [$style.showCol]: getActiveColumn(colIndex, currentRowIndex),
                      [$style.showCol2]: getActiveColumn(colIndex, currentRowActive),
                    },
                  ]"
                  @click="copy(msgLogin)"
                >
                  <p
                    :class="$style.content"
                    :title="getUserName(msgLogin)"
                  >
                    {{ getUserName(msgLogin) }}
                  </p>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td :class="[$style.tdHead, $style.psl0]" />
                <td :class="[$style.tdHead, $style.psl100]">
                  <p
                    :class="$style.content"
                    :title="currentEmailInQuery || selectedComputer.name"
                  >
                    {{ currentEmailInQuery || selectedComputer.name }}
                  </p>
                </td>
                <td :class="$style.tdHead" />
                <td
                  v-for="([msgLogin, values], colIndex) in filteredCompInGroups"
                  :key="msgLogin"
                  :class="[
                    $style.tdRow,
                    {
                      [$style.showCol]: getActiveColumn(colIndex, currentRowIndex),
                      [$style.showCol2]: getActiveColumn(colIndex, currentRowActive),
                    },
                  ]"
                >
                  {{ values.length || '' }}
                </td>
              </tr>
              <template>
                <tr
                  v-for="([msgLogin, values], rowIndex) in filteredCompInGroups"
                  :key="msgLogin"
                  :class="[
                    { [$style.showTr]: rowIndex === currentRowIndex && mapRow[rowIndex].length },
                    { [$style.showTr2]: rowIndex === currentRowActive && mapRow[rowIndex].length },
                  ]"
                  @click="setActiveRow(rowIndex, msgLogin)"
                >
                  <td
                    v-if="groupIndexMap[rowIndex]"
                    :class="[$style.tdHeadGroup, $style.rotate, $style.psl0]"
                    :rowspan="groupIndexMap[rowIndex].length"
                  >
                    {{ groupIndexMap[rowIndex].name }}
                  </td>
                  <td
                    :class="[
                      $style.tdHead,
                      $style.tdRow,
                      $style.showTd,
                      $style.psl100,
                      { [$style.showName]: rowIndex === currentRowIndex },
                    ]"
                    @mouseover="showLogin(rowIndex)"
                    @mouseleave="hideLogin()"
                    @contextmenu.prevent="showMenu($event, msgLogin)"
                  >
                    <p
                      :class="$style.content"
                      :title="getUserName(msgLogin)"
                    >
                      {{ getUserName(msgLogin) }}
                    </p>
                  </td>
                  <td
                    :class="[$style.tdRow, $style.showTd]"
                    @mouseover="showLogin(rowIndex)"
                    @mouseleave="hideLogin()"
                  >
                    {{ values.length || '' }}
                  </td>
                  <td
                    v-for="([msgLogin2, values], colIndex) in filteredCompInGroups"
                    :key="colIndex"
                    :class="[
                      $style.tdRow,
                      {
                        [$style.tdIndex]: rowIndex === colIndex,
                        [$style.showCol]: getActiveColumn(colIndex, currentRowIndex) && currentRowIndex >= rowIndex,
                        [$style.showCol2]: getActiveColumn(colIndex, currentRowActive) && currentRowActive >= rowIndex,
                        [$style.showTd]: colIndex < getColLastIndex(rowIndex) + 1,
                      },
                    ]"
                    @mouseover="showLogin(rowIndex)"
                    @mouseleave="hideLogin()"
                  >
                    {{ getCellValue(msgLogin, msgLogin2) }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div
          v-else-if="isMapView"
          :class="$style.container"
        >
          <v-table
            :columns="columns"
            :data="tableData"
            clickable
            @showMenu="showMenu"
          />
        </div>
        <div
          v-else-if="isComputer"
          :class="$style.emptyResult"
        >
          {{ $t('pages.noData') }}
        </div>
      </scrollable-container>
    </scrollable-container>

    <container
      v-show="isMultiSelectRequired && !isMapView"
      :class="[$style.multiSelect, { [$style.hidden]: !isOpened }]"
    >
      <multi-select
        :is-opened="isOpened"
        @toggle="toggle"
      />
    </container>
    <container
      v-if="!isMapView"
      :class="[$style.multiSelect, { [$style.hidden]: !isOpenedInfo }]"
    >
      <div>
        <div
          :class="[$style.arrow, { [$style.expanded]: !isOpenedInfo }]"
          @click="toggleInfo"
        >
          <img src="@/assets/images/icons/navigation/big-arrow.svg">
        </div>

        <h1 v-show="isOpenedInfo">
          {{ $t('relations.pinnedHeader') }}
        </h1>
      </div>
      <div
        v-if="isOpenedInfo && currentUserInfo"
        :class="$style.containerContact"
      >
        <div :class="$style.contact">
          <div :class="$style.title">
            {{ $t('relations.contactTitle') }}
          </div>
          <div
            v-if="groupHierar"
            :class="$style.company"
          >
            {{ `${groupHierar}${currentUserInfo.username}` }}
          </div>
          <div :class="$style.wrapperContact">
            {{ currentUserInfo.username }}
          </div>
          <div
            v-if="currentUserInfo.msgLogin"
            :class="$style.wrapperContact"
          >
            email:
            <span
              :class="$style.email"
              :title="currentUserInfo.msgLogin"
              @click="copy(currentUserInfo.msgLogin)"
            >
              {{ currentUserInfo.msgLogin }}
            </span>
          </div>
          <div
            v-if="msgTypes.length"
            :class="$style.wrapperContact"
          >
            messenger:
            <img
              v-for="(item, idx) in msgTypes"
              :key="idx"
              :src="getMessengerIconById(item.msgType)"
              :alt="getMessengerLabelById(item.msgType)"
              :title="item.msgLogin"
              :class="$style.msgType"
              @click="copy(item.msgLogin)"
            >
          </div>
          <div
            v-if="currentUserInfo.email"
            :class="$style.wrapperContact"
          >
            email:
            <span
              :class="$style.email"
              :title="currentUserInfo.email"
              @click="copy(currentUserInfo.email)"
            >
              {{ currentUserInfo.email }}
            </span>
          </div>
          <div
            v-if="currentUserInfo.msg"
            :class="$style.wrapperContact"
          >
            messenger:
            <span
              :class="$style.email"
              :title="currentUserInfo.msg"
              @click="copy(currentUserInfo.msg)"
            >
              {{ currentUserInfo.msg }}
            </span>
          </div>
        </div>
        <div v-if="currentValues.length">
          <div
            v-for="([msgLogin, value], index) in currentValues"
            :key="index"
            :class="$style.contact"
          >
            <div :class="$style.title">
              {{ $t('relations.connectionTitle') }}
            </div>
            <div v-if="value.incoming || value.outgoing">
              <div :class="$style.wrapperContact">
                email:
                <span
                  :class="$style.email"
                  :title="currentUserInfo.msgLogin"
                  @click="copy(currentUserInfo.msgLogin)"
                >
                  {{ currentUserInfo.msgLogin }}
                </span>
              </div>
              <div
                v-if="value.incoming"
                :class="$style.wrapperContact"
              >
                <span
                  :class="$style.msgLogin"
                  :title="currentUserInfo.username"
                  @click="copy(currentUserInfo.username)"
                >
                  {{ currentUserInfo.username }}
                </span>
                <span :class="$style.arrowUser">-></span>
                <span
                  :class="$style.msgLogin"
                  :title="getUserName(msgLogin)"
                  @click="copy(getUserName(msgLogin))"
                >
                  {{ getUserName(msgLogin) }}
                </span>
                <span :class="$style.company">{{ value.incoming }}</span>
              </div>
              <div
                v-if="value.outgoing"
                :class="$style.wrapperContact"
              >
                <span
                  :class="$style.msgLogin"
                  :title="getUserName(msgLogin)"
                  @click="copy(getUserName(msgLogin))"
                >
                  {{ getUserName(msgLogin) }}
                </span>
                <span :class="$style.arrowUser">-></span>
                <span
                  :class="$style.msgLogin"
                  :title="currentUserInfo.username"
                  @click="copy(currentUserInfo.username)"
                >
                  {{ currentUserInfo.username }}
                </span>
                <span :class="$style.company">{{ value.outgoing }}</span>
              </div>
            </div>
            <div v-if="value.messenger">
              <div :class="$style.wrapperContact">
                messenger:
                <span
                  :class="$style.email"
                  :title="currentUserInfo.msgLogin"
                  @click="copy(currentUserInfo.msgLogin)"
                >
                  {{ currentUserInfo.msgLogin }}
                </span>
              </div>
              <div :class="$style.wrapperContact">
                <span
                  :class="$style.msgLogin"
                  :title="currentUserInfo.username"
                  @click="copy(currentUserInfo.username)"
                >
                  {{ currentUserInfo.username }}
                </span>
                <span :class="$style.arrowUser">-></span>
                <span
                  :class="$style.msgLogin"
                  :title="getUserName(msgLogin)"
                  @click="copy(getUserName(msgLogin))"
                >
                  {{ getUserName(msgLogin) }}
                </span>
                <span :class="$style.company">{{ value.messenger }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </container>
    <context-menu
      v-if="isMenuVisible"
      id="contextmenu"
      :mouse-x="mouseX"
      :mouse-y="mouseY"
      :email="currentEmail"
      :date-from="dateRange.dateFrom"
      :date-to="dateRange.dateTo"
      :pages="pages"
      @go="closeMenu"
    />

    <groups-menu
      v-if="isGroupsVisible"
      id="groupsmenu"
      :item-id="null"
      :mouse-x="mouseX"
      :mouse-y="mouseY"
      :groups="groups"
      :label="'Меню контакта:'"
      @action="(groupId) => getAction(groupId)"
    />
    <link-to-contact
      v-if="viewLinkContact"
      :current-email="currentEmail"
      @close="viewLinkContact = false"
      @update="updateData"
    />
  </layout-navigation>
</template>

<script>
  import LayoutNavigation from '@/layouts/navigation.vue';
  import StoreBasedDateTimePicker from '@/components/common/filter/store-based-date-time-picker.vue';
  import Treeselect from '@riophae/vue-treeselect';
  import { getRelations, getExtRelations } from '@/api/methods/security';
  import Loader from '@/components/common/blocks/loader.vue';
  import MultiSelect from '@/components/common/filter/multi-select.vue';
  import Container from '@/components/common/blocks/container.vue';
  import ScrollableContainer from '@/components/common/blocks/scrollable-container.vue';
  import Collapse from '@/components/common/logs/additional/_filters/collapse.vue';
  import CheckMark from '@/components/common/filter/check-mark.vue';
  import Plus from '@/components/common/filter/plus.vue';
  import Minus from '@/components/common/filter/minus.vue';
  import ContextMenu from '@/components/common/contextmenu/custom-contextmenu.vue';
  import GroupsMenu from '@/components/common/contextmenu/groups-menu.vue';

  import dayjs from 'dayjs';
  import { isEmpty } from 'lodash';
  import { TYPE_DICT } from '@/components/pages/computers/log/web-mail/const';
  import { getMessengerIconById, getMessengerLabelById } from '@/helpers/messengers';
  import { openToast, TOAST_TYPE } from '@/utils/open-toast';
  import { TYPE_ITEM } from '@/utils/node-attributes';
  import VTable from './table-relations.vue';
  import { COLUMNS, CATEGORIES, GROUPS, GROUPS_OTHER } from './const/const';

  import LinkToContact from './link-to-contact.vue';

  export default {
    components: {
      LayoutNavigation,
      StoreBasedDateTimePicker,
      Treeselect,
      Loader,
      MultiSelect,
      Container,
      ScrollableContainer,
      Collapse,
      CheckMark,
      Minus,
      Plus,
      ContextMenu,
      GroupsMenu,
      VTable,
      LinkToContact,
    },

    data() {
      return {
        viewLinkContact: false,
        isMapView: false,
        isFiltered: false,
        skype: true,
        email: true,
        socNet: true,
        internalContacts: true,
        externalContacts: true,
        incomingCount: 0,
        outgoingCount: 0,
        isOpened: true,
        isOpenedInfo: false,
        isPending: false,
        relations: null,
        contactsMess: [],
        mapContacts: {},
        mapGroups: {},
        mapRealContacts: {},
        selectedComputer: null,
        currentUserInfo: null,
        groupHierar: '',
        activeLogin: null,
        activeLogin2: null,
        incoming: 0,
        outgoing: 0,
        groupMap: {},
        useGroup: [],
        currentRowIndex: null,
        currentRowActive: null,
        currentValues: null,
        msgTypes: [],
        isMenuVisible: false,
        isGroupsVisible: false,
        mouseX: null,
        mouseY: null,
        currentEmail: null,
        currentValuesTable: null,
        pages: [{ name: 'relations', text: 'Открыть в новом окне' }],
        groups: GROUPS,
        columns: COLUMNS,
      };
    },
    computed: {
      isComputer() {
        return this.selectedComputer?.id && this.selectedComputer.type === TYPE_ITEM.COMPUTER;
      },
      currentCompIdInQuery() {
        return this.$route.query?.selectedComputerId;
      },
      currentEmailInQuery() {
        return this.isComputer ? false : this.$route.query?.email;
      },
      checkedComputers() {
        return this.$store.getters['pageSpecificData/checkedComputersList'];
      },
      computersData() {
        return this.$store.getters['pageSpecificData/computersData'];
      },
      computersTree() {
        return this.computersData.tree || [];
      },
      computersTable() {
        return this.computersData.computers.slice().sort((a, b) => b.groupId - a.groupId);
      },
      groupsTable() {
        return this.getGroups(this.computersData.groups, this.computersTable);
      },
      isEmptyData() {
        return !isEmpty(this.filteredGroupMap);
      },
      isMultiSelectRequired() {
        return this.$route.meta.requiredStoreParameters.multiSelect === true;
      },
      groupNameMap() {
        // TODO: рефаторинг
        const filteredGroupMap = Object.entries(this.groupMap).map(([group, emailsObj]) => [
          group,
          Object.fromEntries(Object.entries(emailsObj).filter(([email]) => this.compInGroupsMap.has(email))),
        ]);

        return filteredGroupMap
          .map(([group, computers]) => [group, Object.values(computers)?.length])
          .filter(([, computersInGroup]) => computersInGroup);
      },
      groupIndexMap() {
        const res = {};
        let keyValue = 0;

        this.groupNameMap.forEach(([group, length]) => {
          const currentName = this.getGroupName(group);
          res[keyValue] = {
            name: currentName,
            length,
          };
          keyValue += length;
        });
        return res;
      },
      allowedContacts() {
        if (isEmpty(this.mapContacts)) return [];
        const arrContacts = Object.entries(this.mapContacts)
          .map(([contact, payload]) => {
            if (this.checkedComputers.includes(payload.cid)) return contact;
            return null;
          })
          .filter(Boolean);
        return new Set(arrContacts);
      },
      compInGroupsMap() {
        return new Set(this.filteredCompInGroups.filter(([, values]) => values?.length).map(([email]) => email));
      },
      filteredGroupMap() {
        return Object.fromEntries(
          Object.entries(this.groupMap).map(([topKey, emailsObj]) => {
            if (topKey === 'Other') return [topKey, emailsObj];
            return [
              topKey,
              Object.fromEntries(Object.entries(emailsObj).filter(([email]) => this.allowedContacts.has(email))),
            ];
          }),
        );
      },
      filtereedMapRealContacts() {
        if (isEmpty(this.mapRealContacts)) return {};
        return Object.fromEntries(
          Object.entries(this.mapRealContacts).map(([topKey, emailsObj]) => [
            topKey,
            Object.fromEntries(
              Object.entries(emailsObj).map(([name, data]) => {
                let filtteredData = null;
                if (this.isFiltered) {
                  const isInternal =
                    !this.internalContacts && this.allowedContacts.has(topKey) && this.allowedContacts.has(name);
                  const isExternal =
                    !this.externalContacts && (!this.allowedContacts.has(topKey) || !this.allowedContacts.has(name));
                  if (isInternal || isExternal) filtteredData = [];
                  else filtteredData = this.filtteredData(data);
                }
                return [name, filtteredData || data];
              }),
            ),
          ]),
        );
      },
      computersInGroups() {
        return Object.values(this.filteredGroupMap)
          .flatMap((group) => Object.entries(group))
          .map(([name, data]) => {
            let filtteredData = null;
            if (this.isFiltered) {
              const isInternal = !this.internalContacts && this.allowedContacts.has(name);
              const isExternal = !this.externalContacts && !this.allowedContacts.has(name);
              if (isInternal || isExternal) filtteredData = [];
              else filtteredData = this.filtteredData(data);
            }
            return [name, filtteredData || data];
          });
      },
      filteredCompInGroups() {
        if (this.isFiltered) {
          return this.computersInGroups.filter(([, data]) => data?.length);
        }
        return this.computersInGroups;
      },
      tableData() {
        if (!this.isMapView || !this.isComputer) return {};

        const tableData = {
          establishedContacts: {
            title: CATEGORIES.ESTABLISHED.title,
            data: [],
          },
          otherContacts: {
            title: CATEGORIES.OTHER.title,
            data: [],
          },
        };

        this.filteredCompInGroups.forEach(([msgLogin, values]) => {
          const itemTable = {
            msgLogin,
            values,
            user: this.getUserName(msgLogin),
            email: values.filter((valueItem) => valueItem?.from || valueItem?.to)?.length || '',
            skype: values.filter((skypeItem) => skypeItem?.isSkype)?.length || '',
            socNet: values.filter((socItem) => socItem?.host)?.length || '',
          };

          const currentCategory = this.mapContacts[msgLogin] ? CATEGORIES.ESTABLISHED.key : CATEGORIES.OTHER.key;
          tableData[currentCategory].data.push(itemTable);
        });

        return tableData;
      },
      mapRow() {
        const mapRow = {};
        if (isEmpty(this.mapRealContacts)) return {};
        this.filteredCompInGroups.forEach(([msgLogin], rowIndex) => {
          mapRow[rowIndex] = [];
          if (this.filtereedMapRealContacts[msgLogin]) {
            const currentContacts = Object.entries(this.filtereedMapRealContacts[msgLogin]);
            currentContacts.forEach(([msgLogin2, values]) => {
              const colIndex = this.filteredCompInGroups.findIndex(([login]) => login === msgLogin2);
              if (values?.length && colIndex > -1) mapRow[rowIndex].push(colIndex);
            });
          }
        });
        return mapRow;
      },
      dateRange() {
        return this.$store.getters['filters/formattedDateRange'];
      },
    },
    watch: {
      selectedComputer: {
        async handler() {
          await this.getRelationsData();
        },
      },
    },
    async created() {
      // TODO: вынести whenUpdated в композицию
      this.whenUpdated();
      if (this.currentCompIdInQuery) {
        this.isPending = true;
        this.isMapView = false;
        const unwatch = this.$watch(
          'computersData',
          (newVal) => {
            if (newVal) {
              this.selectedComputer = this.computersData.computers.find(({ id }) => +id === +this.currentCompIdInQuery);
              unwatch();
            }
          },
          { immediate: true },
        );

        this.isPending = false;
      } else if (this.currentEmailInQuery) {
        this.isMapView = false;
        this.isPending = true;
        const { data } = await getExtRelations(
          this.currentEmailInQuery,
          this.dateRange.dateFrom,
          this.dateRange.dateTo,
        );
        const { contactsMess, mapContacts, groupMap, mapGroups, mapRealContacts } = data.result;
        this.contactsMess = contactsMess;
        this.mapContacts = mapContacts;
        this.groupMap = groupMap;
        this.mapGroups = mapGroups;
        this.mapRealContacts = mapRealContacts;

        this.isPending = false;
      }
    },
    methods: {
      filterByEmailKeys(data, allowedEmails) {
        return Object.fromEntries(
          Object.entries(data).map(([topKey, emailsObj]) => [
            topKey,
            Object.fromEntries(Object.entries(emailsObj).filter(([email]) => allowedEmails.includes(email))),
          ]),
        );
      },

      toggle() {
        this.isOpened = !this.isOpened;
      },
      toggleInfo() {
        this.isOpenedInfo = !this.isOpenedInfo;
      },
      getContactValue(values) {
        let incoming = 0;
        let outgoing = 0;
        let messenger = 0;

        values.forEach((item) => {
          if (item?.buddy) messenger++;
          else if (item.direction === TYPE_DICT.INCOMING) incoming++;
          else outgoing++;
        });

        return {
          incoming,
          outgoing,
          messenger,
        };
      },
      getMessengerIconById(type) {
        return getMessengerIconById(type);
      },
      getMessengerLabelById(type) {
        return getMessengerLabelById(type);
      },
      setActiveRow(rowIndex = null, msgLogin) {
        if (this.currentRowActive === rowIndex) {
          this.currentUserInfo = null;
          this.currentRowActive = null;
          this.currentValues = [];
          this.msgTypes = [];
          this.groupHierar = '';
          if (this.isOpenedInfo) this.isOpenedInfo = false;

          return;
        }
        if (!this.isOpenedInfo) this.isOpenedInfo = true;
        if (rowIndex === null) {
          this.currentUserInfo = Object.values(this.mapContacts).find((item) => item.cid === this.selectedComputer.id);
        } else {
          this.currentUserInfo = this.mapContacts[msgLogin];
          this.currentRowActive = rowIndex;
        }
        if (this.currentUserInfo) {
          this.groupHierar = '';
          const currentComp = this.computersData.computers.find(({ id }) => id === this.currentUserInfo.cid);
          this.getGroupHierarchies(currentComp?.groupId);
          this.msgTypes = this.contactsMess.filter(({ cid, msgType }) => msgType && cid === this.currentUserInfo.cid);
        } else {
          this.groupHierar = '';
          this.msgTypes = [];
          this.currentUserInfo = {
            username: msgLogin,
          };
          if (msgLogin.includes('@')) {
            this.currentUserInfo.email = msgLogin;
          } else {
            this.currentUserInfo.msg = msgLogin;
          }
        }

        this.currentValues = Object.entries(this.filtereedMapRealContacts[msgLogin]).map(([login, values]) => {
          const contactValue = this.getContactValue(values);
          return [login, contactValue];
        });
      },

      getGroupHierarchies(groupId) {
        if (groupId) {
          const currentGroup = this.computersData.groups.find(({ id }) => id === groupId);
          this.groupHierar = `${currentGroup.name}\\${this.groupHierar}`;
          if (currentGroup?.parentId) this.getGroupHierarchies(currentGroup.parentId);
        }
      },
      showLogin(rowIndex = null) {
        if (this.currentRowIndex !== rowIndex) this.currentRowIndex = rowIndex;
      },
      hideLogin() {
        this.currentRowIndex = null;
      },
      async getRelationsData() {
        if (this.isComputer) {
          this.isPending = true;
          try {
            const { data } = await getRelations(
              this.selectedComputer.id,
              this.dateRange.dateFrom,
              this.dateRange.dateTo,
            );
            const { contactsMess, mapContacts, groupMap, mapGroups, mapRealContacts } = data.result;
            this.contactsMess = contactsMess;
            this.mapContacts = mapContacts;
            this.groupMap = groupMap;
            this.mapGroups = mapGroups;
            this.mapRealContacts = mapRealContacts;
            this.isPending = false;
          } catch (error) {
            console.error(error);
          } finally {
            this.isPending = false;
          }
        }
      },

      async getExtRelations(email) {
        return getExtRelations(email);
      },
      getActiveColumn(colIndex, currentRow) {
        return this.mapRow?.[currentRow]?.includes(colIndex);
      },
      isLastGroup(rowIndex) {
        const lastGroup = Object.entries(this.groupIndexMap).slice(-1);
        return rowIndex < lastGroup[0][0];
      },
      getColLastIndex(rowIndex) {
        return Math.max(...this.mapRow?.[rowIndex]);
      },
      getCellValue(msgLogin, msgLogin2) {
        const cellValue = this.filtereedMapRealContacts?.[msgLogin]?.[msgLogin2]?.length;
        return cellValue || '';
      },
      getUserName(msgLogin) {
        return this.mapContacts[msgLogin]?.username || msgLogin;
      },
      getGroupName(group) {
        const currentValue = this.mapGroups[group];
        return this.$te(`table.${currentValue}`) ? this.$t(`table.${currentValue}`) : currentValue || '';
      },
      getRowSpan(value, index) {
        if (index) return value.length;
        return value.length + 1;
      },
      getGroups(groups, computersTable) {
        const res = {};
        groups.forEach(({ id, name }) => {
          let length = 0;
          computersTable.forEach(({ groupId }) => {
            if (groupId === id) length++;
          });
          res[id] = { name, length };
        });
        return res;
      },

      async updateData() {
        const { dateFrom, dateTo } = this.$route.query;
        this.$store.commit('filters/updateDateRange', [dateFrom, dateTo]);
        await this.getRelationsData();
      },
      normalizer(node) {
        let { name } = node;
        if (node.nameUser) name = node.nameUser;
        return {
          label: name,
        };
      },
      whenUpdated() {
        const { dateFrom, dateTo } = this.$route.query;
        if (dateFrom && dateTo) {
          this.$store.commit('filters/updateDateRange', [dateFrom, dateTo]);
        }
        const queryMutations = {};

        if (!dateFrom) {
          queryMutations.dateFrom = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss');
        }

        if (!dateTo) {
          queryMutations.dateTo = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
        }

        if (Object.keys(queryMutations).length) {
          this.$router.replace({
            query: {
              ...this.$route.query,
              ...queryMutations,
            },
          });
        }

        this.updateNeeded = true;
      },

      filtteredData(data) {
        let filteredData = data;
        if (this.internalContacts || this.externalContacts) {
          if (this.incomingCount) {
            const incomingCount2 = data.filter((item) => item.direction === TYPE_DICT.INCOMING)?.length;
            if (incomingCount2 && incomingCount2 < this.incomingCount) {
              filteredData = filteredData.filter((item) => item.direction !== TYPE_DICT.INCOMING);
            }
          }
          if (this.outgoingCount) {
            const outgoingCount2 = data.filter((item) => item.direction === TYPE_DICT.OUTGOING)?.length;

            if (outgoingCount2 && outgoingCount2 < this.outgoingCount) {
              filteredData = filteredData.filter((item) => item.direction !== TYPE_DICT.OUTGOING);
            }
          }
        }
        if (!filteredData.length) return [];
        return filteredData.filter((item) => {
          const isEmail = this.email || !item?.from || !item?.to;
          const isSkype = this.skype || !item?.isSkype;
          const isSocNet = this.socNet || !item?.host;
          return isEmail && isSkype && isSocNet;
        });
      },

      toggleSkype() {
        this.skype = !this.skype;
      },
      toggleEmail() {
        this.email = !this.email;
      },
      toggleSocNet() {
        this.socNet = !this.socNet;
      },
      toggleIncomin() {
        this.internalContacts = !this.internalContacts;
      },
      toggleOutcomin() {
        this.externalContacts = !this.externalContacts;
      },
      updateIncoming(action) {
        if (action) this.incomingCount++;
        else if (this.incomingCount > 0) this.incomingCount--;
      },
      updateOutgoing(action) {
        if (action) this.outgoingCount++;
        else if (this.outgoingCount > 0) this.outgoingCount--;
      },

      clearFilters() {
        this.isFiltered = false;
        this.skype = true;
        this.email = true;
        this.socNet = true;
        this.internalContacts = true;
        this.externalContacts = true;
        this.incomingCount = 0;
        this.outgoingCount = 0;
      },
      applyFilters() {
        this.isFiltered = true;
      },
      closeMenu() {
        this.isMenuVisible = false;
        this.isGroupsVisible = false;
      },
      showMenu(event, msgLogin, values) {
        if (!this.isMapView) {
          if (this.mapContacts[msgLogin]?.username) return;
          this.isMenuVisible = true;
        } else {
          if (!this.mapContacts[msgLogin]) this.groups = GROUPS_OTHER;
          else this.groups = GROUPS;
          this.isGroupsVisible = true;
        }
        this.currentEmail = msgLogin;
        this.currentValuesTable = values;
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;

        window.addEventListener('click', (e) => {
          const shouldClose = this.isMapView
            ? !document.getElementById('groupsmenu')?.contains(e.target)
            : !document.getElementById('contextmenu')?.contains(e.target);
          if (shouldClose) {
            this.closeMenu();
            window.removeEventListener('click', e);
          }
        });
      },

      getAction(groupId) {
        let name;
        let query;
        let params;
        if (groupId === 3) {
          this.viewLinkContact = true;
          this.closeMenu();
          return;
        }
        if (groupId === 0) {
          const selectedComputerId = this.mapContacts[this.currentEmail]?.cid || null;
          name = 'relations';
          query = {
            selectedComputerId,
            dateFrom: this.dateRange.dateFrom,
            dateTo: this.dateRange.dateTo,
          };
        } else if (groupId === 1) {
          const logIds = {};
          this.currentValuesTable.forEach(({ table, id }) => {
            if (!logIds[table]) logIds[table] = [];
            logIds[table].push(id);
          });
          name = 'advanced';
          query = {
            isMapData: true,
            logIds: JSON.stringify(logIds),
            dateFrom: this.dateRange.dateFrom,
            dateTo: this.dateRange.dateTo,
          };
        } else if (groupId === 2) {
          const { cid } = this.mapContacts[this.currentEmail];
          const currentComp = this.computersData.computers.find(({ id }) => id === cid);
          const { nameComputer, nameUser } = currentComp;

          name = 'agents-agent-settings';
          params = {
            compName: nameComputer,
            computer: cid,
            log: 'contact',
            type: 'computer',
            userName: nameUser,
          };
        }
        const route = this.$router.resolve({
          name,
          query,
          params,
        });
        window.open(route.href, '_blank', 'noopener,noreferrer');
      },
      async copy(msgLogin) {
        try {
          await navigator.clipboard.writeText(msgLogin);
          openToast(this.$t('toast.copied'), TOAST_TYPE.INFO);
        } catch ($e) {
          openToast(this.$t('toast.notCopied'), TOAST_TYPE.ERROR);
        }
      },
      changeMode(value) {
        this.isMapView = value;
      },
    },
  };
</script>

<style lang="scss" module>
  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: white;
  }

  ::-webkit-scrollbar-thumb {
    background: $branchColor;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: darkgray;
  }

  .mainContainer {
    background: $white;
    box-shadow: $shadow;
    flex-grow: 1;
    width: calc(100vw - 1500px);
    // min-width: 900px;
  }

  .header {
    box-shadow: $shadow;
    display: flex;
    align-items: flex-end;
    gap: 10px;
    margin-bottom: 20px;
    padding: 20px 30px;
  }

  .container {
    padding: 20px;
  }

  .multiSelect {
    margin-left: 20px;
    background-color: $white;
    padding: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    max-width: 250px;
  }

  .hidden {
    min-width: 62px;
  }

  .table {
    padding-right: 20px;
    border-collapse: separate;
    table-layout: fixed;

    thead {
      position: sticky;
      top: 0;
      z-index: 100;
      box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
    }

    .psl0 {
      position: sticky;
      left: 0;
      z-index: 10;
    }

    .psl100 {
      position: sticky;
      left: 100px;
      z-index: 10;
      box-shadow: 2px 0 2px -1px rgba(0, 0, 0, 0.1);
    }

    td,
    th {
      border: 1px solid $borderColor;
      padding: 4px 8px;
      word-break: break-all;
      height: 48px;
      min-height: 48px;
      max-height: 48px;
      width: 100px;
      min-width: 100px;
      max-width: 10px;

      display: table-cell;
      letter-spacing: -0.24px;
    }

    td {
      text-align: center;
      vertical-align: middle;
      position: relative;
    }

    .tdHeadGroup {
      background-color: #dbf1ff;
      color: #232326;
      font-size: 13px;
      line-height: 18px;
      text-align: center;
      vertical-align: middle;
    }

    .tdHead {
      font-size: 13px;
      line-height: 20px;
      text-align: center;
      vertical-align: middle;
      background-color: #f3f3f3;
      cursor: pointer;
    }

    .tdBody {
      font-weight: 300;
      font-size: 12px;
      line-height: 14px;
      text-align: center;
      vertical-align: middle;
    }

    .tdIndex {
      background-color: #f3f3f3;
    }

    .boderNone {
      border: none;
      background-color: #f3f3f3;
    }

    .tdRow {
      cursor: pointer;
    }

    .showTr2 .showTd,
    .showCol2 {
      background-color: rgb(45, 180, 45);
      font-weight: 700;
      color: #ffffff;
      text-shadow: 0 -3px 0 #29bf5b;
      border: none !important;
    }

    .showTr .showTd,
    .showCol {
      background-color: #2985bfcc !important;
      font-weight: 700;
      color: #ffffff !important;
      text-shadow: 0 -3px 0 #2985bf !important;
      border: none !important;
    }
  }

  .emptyResult {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }

  .containerContact {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: calc(100vh - 100px);

    &::-webkit-scrollbar {
      display: none;
    }
  }

  h1 {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $black;
    margin-bottom: 20px;
    display: inline-flex;
    margin-left: 20px;
  }

  .arrow {
    cursor: pointer;
    display: inline-flex;
    transform: rotate(-90deg);
  }

  .expanded {
    transform: rotate(90deg);
  }

  .contact {
    position: relative;
    padding: 8px 7px 10px 15px;
    border: 1px solid #cccccc;
    font-weight: 300;
    font-size: 14px;
    line-height: 26px;
    margin-top: 15px;
  }

  .title {
    position: absolute;
    background: #515151;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    left: 12px;
    top: -10px;
    width: fit-content;
    padding: 0 4px;
    color: #ffffff;
  }

  .company {
    font-weight: 400;
  }

  .wrapperContact {
    display: flex;
    gap: 5px;
  }

  .arrowUser {
    width: 24px;
    flex-shrink: 0;
  }

  .msgLogin {
    max-width: 60px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
  }

  .email {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #2985bf;
    cursor: pointer;
  }

  .collapseContainer {
    border: 1px solid $borderColor;
    width: 270px;
    background-color: $white;
    padding: 0 16px 16px;
  }

  .headerText {
    color: #7e7e7e;
    font-weight: 300;
    font-size: 12px;
    line-height: 30px;
    margin-top: 10px;
  }

  .textContainer {
    display: inline-block;
    padding-left: 10px;
    font-weight: 300;
    font-size: 14px;
  }

  .btnFilters {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
  }

  .clearFilters {
    background-color: $white;
    border: none;
    font-weight: 300;
    font-size: 14px;
    line-height: 30px;
    text-decoration: underline;
    text-decoration-style: solid;
    color: #7e7e7e;
    cursor: pointer;
    padding: 0;

    &:hover {
      opacity: 0.8;
    }

    &:active {
      opacity: 0.5;
    }
  }

  .applyFilters {
    font-size: 14px;
    color: $white;
    cursor: pointer;
    border-radius: 2px;
    background-color: #2985bf;
    border: none;
    padding: 5px;

    &:hover {
      opacity: 0.8;
    }

    &:active {
      opacity: 0.5;
    }
  }

  .checkBoxContainer {
    display: flex;
    gap: 12px;
  }

  .customCheckBoxContainer {
    .customCheckbox {
      border: 0;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }

    input:checked + label > svg {
      animation: draw-checkbox ease-in-out 0.2s forwards;
    }

    label:active::after {
      background-color: #fbfbfb;
    }

    label {
      color: black;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      cursor: pointer;
      position: relative;
      display: block;

      &:after {
        content: '';
        height: 14px;
        width: 14px;
        float: left;
        border: 1px solid #9f9f9f;
        border-radius: 4px;
        transition: 0.15s all ease-out;
        background-color: white;
      }
    }

    input:checked + label:after {
      background-color: $blue;
      border: 1px solid $blue;
    }

    svg {
      position: absolute;
      left: 4px;
      top: 4px;
      stroke-dasharray: 33;
    }

    @keyframes draw-checkbox {
      0% {
        stroke-dashoffset: 33;
      }

      100% {
        stroke-dashoffset: 0;
      }
    }
  }

  .inputContainer {
    display: flex;
  }

  .countContainer {
    display: flex;
    flex-direction: column;
    border: 1px solid #e3e3e3;
    padding: 8px 16px 2px;
    width: 118px;
  }

  .countText {
    color: #7e7e7e;
    font-weight: 300;
    font-size: 12px;
    white-space: nowrap;
  }

  .countWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .defaultButton {
    all: unset;
    display: flex;
    align-items: center;
    height: 17px;
    width: 17px;
    cursor: pointer;
  }

  .numberInput {
    -webkit-appearance: none;
    -moz-appearance: textfield;
    appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    width: 52px;
    height: 28px;
    padding: 0;
    text-align: center;
    border: none;
    outline: none;
    font-weight: 300;
    font-size: 14px;
  }

  .plus {
    font-weight: 700;
    font-size: 20px;
    padding: 0px 5px;
  }

  .msgType {
    cursor: pointer;
  }

  .content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .control {
    display: flex;
    align-items: flex-end;
  }

  .box {
    border: 1px solid #dfdfdf;
    height: 40px;
    display: flex;
    width: 40px;
    align-items: center;
    justify-content: center;
    margin: 0px 5px;
    background: #f5f5f5;
    cursor: pointer;
  }

  .activeBox {
    background: #e9f7ff;
    border-color: #b1d6ed;
  }
</style>
<style>
  .computersTree {
    width: 25%;
    max-width: 400px;
  }

  .computersTree .vue-treeselect__control {
    border-radius: 0px;
  }
</style>
